import React, { forwardRef } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList } from "recharts";
import { SectionCard, InfoRow, ChartTooltip, fmtNum, fmtCompact, barLabelStyle, C, axisTick } from "../shared";

const EarningsSection = forwardRef(({ earnings }, ref) => (
  <SectionCard ref={ref} id="earnings" icon="earnings" title="Earnings">
    <div className="tdash-g2">
      <div>
        <InfoRow label="Latest EPS"      value={earnings.latest_eps != null ? `Rs. ${fmtNum(earnings.latest_eps)}` : null} />
        <InfoRow label="Last Annual EPS" value={earnings.last_annual_eps != null ? `Rs. ${fmtNum(earnings.last_annual_eps)}` : null} />
        <InfoRow label="Trailing EPS"    value={earnings.trailing_eps != null ? `Rs. ${fmtNum(earnings.trailing_eps)}` : null} />
        <InfoRow label="P/E Ratio"       value={earnings.pe_ratio != null ? `${fmtNum(earnings.pe_ratio)} x` : null} />
        <InfoRow label="EPS Growth"      value={earnings.eps_growth != null ? `${fmtNum(earnings.eps_growth)}%` : null} />
      </div>
      <div>
        <div style={{ fontSize: 11, color: C.muted, textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: 8 }}>Annual EPS</div>
        {earnings.annual_chart?.length > 0 ? (
          <ResponsiveContainer width="100%" height={210}>
            <BarChart data={earnings.annual_chart} margin={{ top: 18, right: 8, left: 0, bottom: 0 }} barCategoryGap="35%">
              <CartesianGrid strokeDasharray="3 3" stroke={C.grid} vertical={false} />
              <XAxis dataKey="year" tick={axisTick} tickLine={false} axisLine={{ stroke: C.border }} />
              <YAxis tick={axisTick} tickLine={false} axisLine={false} width={38} />
              <Tooltip content={<ChartTooltip />} cursor={{ fill: "rgba(255,255,255,0.03)" }} />
              <Bar dataKey="eps" name="EPS" fill={C.green} radius={[3, 3, 0, 0]} maxBarSize={18} isAnimationActive={false}>
                <LabelList dataKey="eps" position="top" style={barLabelStyle} formatter={(v) => fmtNum(v)} />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        ) : <div className="tdash-muted">No data</div>}
      </div>
    </div>
  </SectionCard>
));

export default EarningsSection;
